import { Typography } from "@joonapp/web-shared"

import { useSendMailModalStore } from "./hooks/useSendMailModalStore"
import { InventoryItem } from "../../../../types"
import { getShopItemText } from "../../../../util/util"

interface GiftItemProps {
  gift: InventoryItem
}

const GiftItem = ({ gift }: GiftItemProps) => {
  const { selectedGift, setSelectedGift } = useSendMailModalStore()

  const isSelected = selectedGift?.id === gift.id

  return (
    <button className="w-full" onClick={() => setSelectedGift(gift)}>
      <div
        className={`flex flex-row items-center gap-2 bg-white p-2 rounded-md border ${
          isSelected ? "border-primary shadow-md" : "border-borderPrimary"
        }`}
      >
        <img
          src={gift.shop_item.image_url}
          style={{
            width: "15vw",
            maxWidth: "50px",
            height: "auto",
          }}
          alt="Gift"
        />
        <div className="flex flex-col gap-0 items-start justify-start">
          <Typography
            variant="bodySmallBold"
            style={{ lineHeight: "1.25rem" }}
            textAlign="left"
          >
            {gift.shop_item.name}
          </Typography>
          <Typography
            variant="bodySmall"
            style={{ lineHeight: "1.25rem" }}
            textAlign="left"
          >
            {gift.shop_item.description + " "}
            {getShopItemText(gift.shop_item)}
          </Typography>
        </div>
      </div>
    </button>
  )
}

export default GiftItem
